import { SummaryCell } from "./cell";
import { FooterRow } from "./row";
/**
 * Syntactic sugar. Do not support HOC.
 */
function Summary({ children }) {
    return children;
}
Summary.Row = FooterRow;
Summary.Cell = SummaryCell;
export { Summary };
